export default {
  brand: {
    primary: '#9000ff'
  },
  electricViolet: '#9000FF',
  periwinkle: '#8d85ee',
  primaryLight: '#F6EBFF',
  errorLight: '#FFF0E8',
  successLight: '#E1F8F0',
  warningLight: '#FFF0E8',
  dark: '#180a33',
  error: '#ff4d4d',
  grey: {
    100: '#f1f5f7',
    200: '#e0e7ec',
    300: '#cfdae1',
    400: '#acbec7',
    500: '#85909a',
    600: '#4a5365'
  },
  success: '#00a881',
  warning: '#ff884d',
  white: '#ffffff'
};